import { addBlockFromAsset, reorderBlocks } from "./builderDraft";

/**
 * builderDnd — EMAILS-IMPL-015
 *
 * Translates one @dnd-kit `DragEndEvent`-shaped object into a draft
 * transition, kept as a PURE function deliberately separate from the
 * actual `DndContext` wiring in CreativeEmailBuilder.jsx -- this
 * codebase has no existing precedent for simulating real pointer/
 * keyboard drag gestures in jsdom (confirmed empirically: no test
 * anywhere touches @dnd-kit's PointerSensor/KeyboardSensor or mocks
 * `getBoundingClientRect` for collision detection), so this function is
 * the actual, reliably-testable unit -- tests call it directly with a
 * synthetic `{active, over}` object, exactly the shape @dnd-kit's own
 * `onDragEnd` receives, without needing a real DOM drag at all.
 */

// The always-present trailing drop target representing "append at the
// end of the Canvas" -- both for an empty Canvas (first block ever) and
// for an explicit bottom-insert once blocks already exist (§13).
export const CANVAS_END_DROP_ID = "__canvas_end__";

export function resolveDragEnd(draft, event) {
  const { active, over } = event || {};
  if (!over || !active) return draft;

  const activeData = active.data?.current;
  if (!activeData) return draft;

  if (activeData.type === "library-item") {
    const rawIndex = over.id === CANVAS_END_DROP_ID ? draft.canvasLayout.length : draft.canvasLayout.findIndex((b) => b.blockId === over.id);
    const index = rawIndex === -1 ? draft.canvasLayout.length : rawIndex;
    return addBlockFromAsset(draft, { key: activeData.key, assetId: activeData.assetId, version: activeData.version }, index);
  }

  if (activeData.type === "canvas-block") {
    if (active.id === over.id) return draft;
    const ids = draft.canvasLayout.map((b) => b.blockId);
    const oldIndex = ids.indexOf(active.id);
    const newIndex = over.id === CANVAS_END_DROP_ID ? ids.length - 1 : ids.indexOf(over.id);
    if (oldIndex === -1 || newIndex === -1) return draft;

    const reordered = [...ids];
    reordered.splice(oldIndex, 1);
    reordered.splice(newIndex, 0, active.id);
    return reorderBlocks(draft, reordered);
  }

  return draft;
}
